import React from 'react';
import { connect } from 'react-redux';

const translateDecorator = (section) => (Wrapped) => {
  const TranslateWrapper = connect(({ translate: { locale, translate } }) => ({
    locale,
    t: (str) => translate(section, str),
  }))((props) => <Wrapped {...props} />);

  TranslateWrapper.displayName = `translate(${Wrapped.displayName || Wrapped.name || 'Component'})`;

  return TranslateWrapper;
};

export default translateDecorator;
